import { useUser } from "./useUser";

export const usePermission = (permission: string): boolean => {
  const { data: user } = useUser();

  return user?.permissions.includes(permission) ?? false;
};
